/* =============================================================
 * import
 * ========================================================== */
import {gsap} from 'gsap';
import {CustomEase} from "gsap/CustomEase";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {SplitText} from "gsap/SplitText";
// import {isMobile, isSafari} from "./common";

gsap.registerPlugin(CustomEase, ScrollTrigger, SplitText);
CustomEase.create("fadeCurtain", ".25, .46, .45, .94");

export default function mvAnimation(elm, barba = false) {

  // barba時のみ実行
  if (barba) {

    const tl = gsap.timeline();
    const mv = elm.querySelector('.mv');
    const mainWrapper = elm.querySelector('.main_wrapper');

    if (mv) {

      const breadcrumb = mv.querySelector('.breadcrumb_list');
      const ttl = mv.querySelector('.main_ttl_jp');
      const ttlEn = mv.querySelector('.main_ttl_en');
      const visual = mv.querySelector('.main_visual');
      let ttlTxt;
      let ttlEnTxt;
      let visualImg;

      if (breadcrumb) {
        gsap.set(breadcrumb, {
          opacity: 0,
          y: -20,
        });
      }

      if (ttl) {
        if (!elm.classList.contains('single')) {
          ttlTxt = new SplitText(ttl, {type: "chars"});
          gsap.set(ttl, {
            opacity: 0,
          });
        } else {
          gsap.set(ttl, {
            opacity: 0,
            y: -20,
          });
        }
      }

      if (ttlEn && !elm.classList.contains('single')) {
        ttlEnTxt = new SplitText(ttlEn, {type: "chars"});
        gsap.set(ttlEn, {
          opacity: 0,
        });
      }

      if (mainWrapper) {
        gsap.set(mainWrapper, {
          y: -20,
          opacity: 0,
        });
      }

      if (visual) {
        visualImg = mv.querySelector('.main_visual_img_bg');
        gsap.set(visual, {
          // opacity: 0,
          webkitClipPath: 'inset(0 0 100% 0)',
          clipPath: 'inset(0 0 100% 0)',
        });
        gsap.set(visualImg, {
          scale: 1.3,
        });
      }

      const animate = () => {
        if (ttl) {
          if (!elm.classList.contains('single')) {
            tl
              .to(ttl, {
                  duration: .8,
                  opacity: 1,
                  ease: "fadeCurtain",
                },
              )
              .from(ttlTxt.chars, {
                  duration: .8,
                  opacity: 0,
                  y: 60,
                  stagger: 0.05,
                  ease: "fadeCurtain",
                }, "<",
              );
          } else {
            tl
              .to(ttl, {
                  duration: .8,
                  opacity: 1,
                  y: 0,
                  ease: "fadeCurtain",
                },
              );
          }
        }

        if (ttlEn && !elm.classList.contains('single')) {
          tl
            .to(ttlEn, {
                duration: .8,
                opacity: 1,
                ease: "fadeCurtain",
              }, "<",
            )
            .from(ttlEnTxt.chars, {
                duration: .8,
                opacity: 0,
                y: 60,
                stagger: 0.05,
                ease: "fadeCurtain",
              }, "<",
            );
        }

        if (visual) {
          tl
            .to(visual, {
                duration: .5,
                // opacity: 1,
                webkitClipPath: 'inset(0 0 0% 0)',
                clipPath: 'inset(0 0 0% 0)',
                ease: "fadeCurtain",
              }, ">-=.1",
            )
            .to(visualImg, {
                duration: 2,
                scale: 1,
                ease: "fadeCurtain",
              }, "<",
            );
        }

        tl
          .to(breadcrumb, {
              duration: .8,
              opacity: 1,
              y: 0,
              ease: "fadeCurtain",
            }, "<",
          )
          .to(mainWrapper, {
              duration: .8,
              opacity: 1,
              y: 0,
              ease: "fadeCurtain",
            }, "<+=.3",
          )
        ;
      };

      animate();

      /*
      // Barba.jsの遷移後に呼ばれた場合と、通常のロード時の分岐
      if (barba) {
        // Barba.jsの遷移後
        animate();
      } else {
        // アニメーション開始時の要素設定
        window.onload = function() {
          animate();
        };
      }
      */

    }

  }

}